var _defs, _polyline, _polyline2, _polyline3, _polyline4, _path, _path2, _circle, _path3, _polyline5, _path4, _path5, _circle2, _path6, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPsAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0aadd6;}.cls-2{fill:none;stroke:#2f2d3b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-3{fill:#e6e7e8;}.cls-4{fill:#2992cc;}"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2 12 2 2 12 2"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "62 12 62 2 52 2"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "2 52 2 62 12 62"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "62 52 62 62 52 62"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M48,13V51c0,1.1-.9,2-2,2H12v2c0,1.1,.9,2,2,2H50c1.1,0,2-.9,2-2V17l-4-4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M52,17h-8c-1.1,0-2-.9-2-2V7l10,10Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 15,
    r: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22,18c-2.21,0-4,1.79-4,4v2h4v-6Z"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "32 7 42 7 52 17 52 35"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52,39v16c0,1.1-.9,2-2,2H14c-1.1,0-2-.9-2-2V9c0-1.1,.9-2,2-2h14"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M52,17h-8c-1.1,0-2-.9-2-2V7l10,10Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 22,
    cy: 15,
    r: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22,18h0c2.21,0,4,1.79,4,4v2h-8v-2c0-2.21,1.79-4,4-4Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30,
    y1: 20,
    x2: 36,
    y2: 20
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 36,
    y1: 30,
    x2: 38,
    y2: 30
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 42,
    y1: 30,
    x2: 46,
    y2: 30
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18,
    y1: 34,
    x2: 24,
    y2: 34
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30,
    y1: 24,
    x2: 46,
    y2: 24
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18,
    y1: 30,
    x2: 32,
    y2: 30
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 28,
    y1: 34,
    x2: 46,
    y2: 34
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18,
    y1: 38,
    x2: 38,
    y2: 38
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2,
    y1: 42,
    x2: 62,
    y2: 42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPsAi);
export default __webpack_public_path__ + "static/media/ps_ai.3ed3a2ade01e3e4e1f813b653d2df2ac.svg";
export { ForwardRef as ReactComponent };